import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialogueRoot: {
    position: "fixed",
    inset: 0,
    zIndex: theme.zIndex.drawer - 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loaderRoot: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  iconBlock: {
    width: "23px",
    height: "23px",
    "& img": {
      width: "100%",
      height: "100%",
    },
    left: "34%",
    bottom: "35%",
    position: "absolute",
  },
  loadingText: {
    color: "#ffffff",
    fontSize: "15px",
    fontWeight: "600",
    marginTop: "16px",
    textAlign: "center",
  },
  loaderWrapper: {
    position: "relative",
    width: "48px",
    height: "48px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loaderCounter: {
    position: "absolute",
    color: "#ffffff",
    fontSize: "12px",
    fontWeight: "600",
  },
  loader: {
    borderRadius: "50%",
    width: "48px",
    height: "48px",
    position: "absolute",
    borderTop: "3px solid rgba(72,119,229, 0.2)",
    borderRight: "3px solid rgba(72,119,229, 0.2)",
    borderBottom: "3px solid rgba(72,119,229, 0.2)",
    borderLeft: "3px solid #4877e5",
    "-webkit-transform": "translateZ(0)",
    "-ms-transform": "translateZ(0)",
    transform: "translateZ(0)",
    "-webkit-animation": "$load8 0.8s infinite linear",
    animation: "$load8 0.8s infinite linear",
    "&::after": {
      borderRadius: "50%",
      width: "48px",
      height: "48px",
      position: "relative",
    },
  },
  "@-webkit-keyframes load8": {
    "0%": {
      "-webkit-transform": "rotate(0deg)",
      transform: "rotate(0deg)",
    },
    "100%": {
      "-webkit-transform": "rotate(360deg)",
      transform: "rotate(360deg)",
    },
  },
  "@keyframes load8": {
    "0%": {
      "-webkit-transform": "rotate(0deg)",
      transform: "rotate(0deg)",
    },
    "100%": {
      "-webkit-transform": "rotate(360deg)",
      transform: "rotate(360deg)",
    },
  },
}));

export { useStyles };
